module.exports = __webpack_public_path__ + "img/Icon_No_legal_proceedsv.745c6bc1.svg";